<app-table
    tableKey="dashboardClientsWithoutRecentWork"
    [gridData]="store.data.getClientsWithoutRecentWork()"
    [hideCheckboxes]="true"
    [columns]="columns()"
    [translatePrefix]="prefix"
    [showClearFilter]="false"
    [showFilters]="false"
    [rowsPerPageOptions]="[10, 25, 50]"
    [additionalFilter]="additionalFilter()"
    [refreshCallback]="store.api.getClientsWithoutRecentWork"
    [refreshCallbackFragment]="fragment"
>
    <ng-template pTemplate="lastWorkAt" let-data="data">
        @if (data) {
            <div>{{ data | localDate: 'd.M.y H:mm' }}</div>
        } @else {
            <div>{{ prefix + 'never' | translate }}</div>
        }
    </ng-template>
</app-table>
